<template>
  <section class="summary">
    <template v-if="$slots.default">
      <slot></slot>
    </template>
    <template v-else>
      <h3>{{ $t("Short summary") }}</h3>
    </template>
    <div class="summary-list">
      <div class="item">
        <span>{{ $t("Products") }}</span>
        <span>{{ formattedPrice(getProductPrice()) }}</span>
      </div>
      <div class="item" v-if="orderServices.length">
        <span>{{ $t("Services") }}</span>
        <span>{{ formattedPrice(getOrderServicePrice()) }}</span>
      </div>
      <div class="item" v-if="discountCoupon">
        <span>{{ $t("Discount code") }} "{{ discountCoupon.name }}"</span>
        <span>-{{ formattedPrice(discountPrice) }}</span>
      </div>
      <div class="item">
        <span>{{ $t("Payment") }}</span>
        <span>{{ priceText(cartData.payment) }}</span>
      </div>
      <div class="item">
        <span>{{ $t("Shipping") }}</span>
        <span>
          {{
            hasFreeShipping && (cartData.shipping && cartData.shipping.can_free)
              ? $t("Free")
              : priceText(cartData.shipping)
          }}</span
        >
      </div>
      <div class="item">
        <span>{{ $t("Total") }}</span>
        <span class="bold">{{ totalPrice }}</span>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters } from "vuex";
import useOrderService from "../../../packages/views/order-service/useOrderService";
import useCart from "../useCart";

export default {
  computed: {
    ...mapGetters({
      cartData: "cart/getCartData",
      discountCoupon: "discountCoupon/getData", // [PACKAGE] - discount coupon
      orderServices: "orderService/getOrderServices", // [PACKAGE] - order service
      hasFreeShipping: "cart/getHasFreeShipping",
    }),
  },
  methods: {
    priceText(item) {
      if (!item) {
        return "-";
      }

      return item.price == 0
        ? this.$t("Free")
        : this.formattedPrice(item.price);
    },
  },
  setup(props) {
    const { formattedPrice, getProductPrice, totalPrice, discountPrice } =
      useCart();
    // [PACKAGE] - order service
    const { getOrderServicePrice } = useOrderService();

    return {
      formattedPrice,
      getProductPrice,
      totalPrice,
      discountPrice,
      getOrderServicePrice,
    };
  },
};
</script>
